export class NotaFiscal {
    public Id: number;
    public Discriminacao: string;
    public Valor: number;
    public DataEmissao: string;
    public UsuarioEmissaoId: number;
    public NumeroRPS: number;
    public ReferenciaClasseImposto: string;
    public ParticipanteTomadorId: number;
    public ParticipanteNome: string;
    public StatusNota: string;
    public MotivoStatus: string;
    public CodigoVerificacao: string;
    public NFSpdf: string;
    public NFSxml: string;
    public RPSpdf: string;
    public Emitida: boolean;
    public UUID: string;
    public ReceberId: number;

    constructor(){
        this.Valor = 0;
    }
}